"use client";
import { useTranslations } from "next-intl";
import { useActionState, useEffect, useRef } from "react";
import { useFormStatus } from "react-dom";
import { addMessage } from "@/components/Messages";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { type FormState, handleSubmitContactForm } from "./actions";

export const SignUpPodcastInsightsComponent = () => {
  const t = useTranslations("podcastInsightsLanding");
  const [formState, action] = useActionState<FormState, FormData>(handleSubmitContactForm, {
    email: "",
    message: "",
  });
  const prevFormStateRef = useRef(formState);

  useEffect(() => {
    // Only show messages when formState changes (after form submission)
    if (formState !== prevFormStateRef.current) {
      prevFormStateRef.current = formState;
      if ("error" in formState) {
        addMessage({
          type: "ERROR",
          text: t("errorMessage"),
        });
      } else if (formState.email) {
        addMessage({
          type: "SUCCESS",
          text: t("successMessage"),
        });
      }
    }
  }, [formState, t]);

  return (
    <form action={action} className="space-y-4">
      <Input name="email" type="email" placeholder={t("emailPlaceholder")} required />
      <Input name="message" type="text" placeholder={t("messagePlaceholder")} />
      <SubmitButton />
    </form>
  );
};

const SubmitButton = () => {
  const t = useTranslations("podcastInsightsLanding");
  const { pending } = useFormStatus();

  return (
    <Button loading={pending} disabled={pending} type="submit" className="w-full">
      {t("submitButton")}
    </Button>
  );
};
